/**
 * Theme Type Definitions for USLand
 *
 * Clean, professional white theme with USLAND brand colors (red, white, blue)
 */

/**
 * Color theme type
 */
export type ColorTheme = 'usland';

/**
 * Theme mode - Light mode with optional dark support
 */
export type ThemeMode = 'light' | 'dark';

/**
 * Theme storage key for localStorage
 */
export const THEME_STORAGE_KEY = 'usland-theme-mode';

/**
 * Default theme mode - Light mode
 */
export const DEFAULT_THEME_MODE: ThemeMode = 'light';

/**
 * Default color theme - USLAND
 */
export const DEFAULT_THEME: ColorTheme = 'usland';

/**
 * Theme configuration interface
 */
export interface ThemeConfig {
  /** Display name shown in UI */
  name: string;
  /** Short description */
  description: string;
  /** Primary color as HSL value */
  primaryColor: string;
  /** Secondary accent color */
  secondaryColor?: string;
  /** CSS class name */
  className: string;
  /** Theme category */
  category: 'professional' | 'cyberpunk' | 'minimal';
}

/**
 * USLAND Theme Configuration
 * Clean, professional white theme with USLAND brand colors
 */
export const USLAND_THEME: ThemeConfig = {
  name: 'USLAND',
  description: 'Clean, professional white theme with USLAND brand colors (red, white, blue).',
  primaryColor: '215 85% 50%',
  secondaryColor: '0 75% 50%',
  className: 'theme-usland',
  category: 'professional',
};

/**
 * High contrast mode type
 */
export type HighContrastMode = 'off' | 'on';

export const HIGH_CONTRAST_STORAGE_KEY = 'usland-high-contrast';
export const DEFAULT_HIGH_CONTRAST: HighContrastMode = 'off';

/**
 * Font size scaling options
 */
export type FontSize = 'small' | 'medium' | 'large' | 'xlarge';

export const FONT_SIZE_STORAGE_KEY = 'usland-font-size';
export const DEFAULT_FONT_SIZE: FontSize = 'medium';

export const FONT_SIZE_SCALES: Record<FontSize, number> = {
  small: 90,
  medium: 100,
  large: 110,
  xlarge: 125,
};

/**
 * Reduced motion mode type
 */
export type ReducedMotionMode = 'off' | 'on';

export const REDUCED_MOTION_STORAGE_KEY = 'usland-reduced-motion';
export const DEFAULT_REDUCED_MOTION: ReducedMotionMode = 'off';
